/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/

// Re-usable custom Effect decalaration
import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { getAuthenticationDetailsFromSessionStorage } from "helpers/common";
import {
  getAuthTokenFromSessionStorage,
  removeAuthenticationFromSessionStorage,
  setAuthenticationInSessionStorage,
} from "helpers/auth-session";
import { client } from "actions";

const useVerifyLogin = () => {
  const [cookies, setCookie] = useCookies([]);
  const [login, setLogin] = useState(false);

  useEffect(() => {
    let isCancelled = false;

    const checkIfLoggedIn = async () => {
      const authentication = getAuthenticationDetailsFromSessionStorage();
      const capturedToken = authentication?.authToken;

      if (capturedToken) {
        try {
          const tokenIntegrityRes = await client.get("/validate-token", {
            headers: { authorization: capturedToken },
          });
          const { tokenIntegrity = false } = tokenIntegrityRes?.data;
          if (
            tokenIntegrity &&
            !isCancelled &&
            getAuthTokenFromSessionStorage() === capturedToken
          ) {
            setAuthenticationInSessionStorage(authentication);
            setLogin(true);
          }
        } catch (error) {
          if (
            isCancelled ||
            getAuthTokenFromSessionStorage() !== capturedToken
          ) {
            return;
          }
          removeAuthenticationFromSessionStorage();
          setCookie(
            "authentication",
            { authToken: null },
            {
              path: "/",
              maxAge: 1,
            }
          );
          setLogin(false);
          console.log("verify login error", error);
        }
      }
    };

    if (!login) checkIfLoggedIn();
    return () => {
      isCancelled = true;
    };
  }, []);

  return login;
};
export default useVerifyLogin;
